.container {
    composes: container from "../../styles/composable/layout.module.css";
}

.stage {
    // Media renders at its natural ratio, but the block never gets taller
    // than 16:9 — narrower media is pillarboxed against the theme background.
    aspect-ratio: max(var(--media-aspect-ratio, calc(16 / 9)), calc(16 / 9));
    display: flex;
    justify-content: center;
}

.mediaSizer {
    height: 100%;
    aspect-ratio: var(--media-aspect-ratio, calc(16 / 9));

    :is(img, video) {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.media {
    display: block;
    width: 100%;
    height: 100%;
}
